<template>
  <div class="page-container">
    <Filter ref="filterRef" :params="params" @search="searchData"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="robotSn" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column :label="$t('collect.healthscorelist.ctrlCabCode')">
        <template #default="scope">
          <span v-if="!['0','-1'].includes(scope.row.cabinetSn)">{{scope.row.cabinetSn}}</span>
          <el-popover
            placement="top-start"
            :width="150"
            trigger="hover"
            v-if="!scope.row.cabinetSn?.toLowerCase().startsWith('cab') && !['0','-1'].includes(scope.row.cabinetSn)"
          >
            <template #default>{{$t('collect.healthscorelist.ctrlCabCodeInvalid')}}</template>
            <template #reference>
              <i class="el-icon-question" style="margin-left: 6px;color: #E6A23C;cursor: pointer;"></i>
            </template>
          </el-popover>
   
        </template>
      </el-table-column>
      <!-- <el-table-column prop="customerName" :label="$t('activity.signin.customerName')" /> -->
      <el-table-column prop="updateTime" :label="$t('collect.healthscorelist.updateTime')" />
      <el-table-column :label="$t('collect.healthscorelist.healthScore')">
        <template #default="scope">
          <el-progress
            type="circle"
            :percentage="scope.row.score"
            class="progress-text"
            :color="scope.row.color"
             width="60"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column :label="$t('collect.healthscorelist.healthTrend')" width="150">
        <template #default="scope">
          <el-button
            type="text"
            size="small"
            @click="handleClick(scope.row)"
            >{{$t('collect.healthscorelist.healthTrend')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
  </div>
</template>

<script>
import { request } from '@/utils/request'
import { common } from '../../common/mixin'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import dayjs from 'dayjs'
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data () {
    return {
      params: [
        {
          key: 'robotSN',
          value: '',
          label: this.$t('activity.packetjoin.robotCode')
        },
        {
          key: 'cabinetSN',
          value: '',
          label: this.$t('collect.healthscorelist.ctrlCabCode')
        },
        // {
        //   key: 'customerName',
        //   value: '',
        //   label: this.$t('activity.signin.customerName')
        // },
        {
          type: 'Date',
          key: 'dateRange',
          // value: [
          //   dayjs().subtract(7, 'day').format('YYYY-MM-DD') + ' 00:00:00',
          //   dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          // ],
          label: this.$t('collect.healthscorelist.updateDate'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': this.$t('activity.detail.to'),
            'start-placeholder': this.$t('activity.list.startDate'),
            'end-placeholder': this.$t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: []
    }
  },
  created () {},
  mounted () {
    this.$refs.filterRef?.searchData()
  },
  methods: {
    getData () {
      console.log(this.query)
      request('getHealthScoreList', {
        ...this.query,
        page: this.page,
        size: this.size,
        startTime: this.query.dateRange?.[0],
        endTime: this.query.dateRange?.[1]
      })
        .then(data => {
          this.tableDataList = data.records
          this.total = parseInt(data.total)
          this.tableDataList.map(item => {
            if (item.score <= 0.2) {
              item.color = 'orange'
            } else if (0.2 < item.score < 0.8) {
              item.color = 'blue'
            } else {
              item.color = 'green'
            }
            item.score = item.score && item.score * 100
          })
        })
        .catch(error => {
          console.error(error)
        })
    },
    getDataMap () {
      try {
        request('getArea', {
          parentId: 1
        }).then(data => {
          this.provinceList = data
        })
        request('getRobotStatusMap').then(data => {
          this.robotStatusList = data
        })
        request('getIndustryList').then(data => {
          this.industryList = data
        })
      } catch (error) {
        console.log(error)
      }
    },
    searchData (data) {
      this.query = data
      this.getData()
    },
    updatePage (page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    handleClick (row) {
      this.$router.push({
        path: '/collect/healthScoreTrend',
        query: { robotSn: row.robotSn }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.progress-text {
  font-size: 12px;
}
</style>
